import { trackingSteps } from '@/mocks/homeData';

export default function Tracking() {
  return (
    <section id="tracking" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <span className="text-xs font-medium tracking-widest text-primary-600 uppercase">
                系列爆料追踪
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
                同一条线索，从浮现到复盘
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                下面是一条真实存在的规则调整线索在公开渠道中的完整走向。我们把每次信息增量按天串起来，
                并标注当前的核实状态，方便你判断哪些是已确认事实、哪些仍待补充。
              </p>

              <div className="bg-background-50 border border-background-200 rounded-lg p-5">
                <div className="text-xs text-foreground-500 mb-1">当前追踪线索</div>
                <div className="font-heading text-base font-semibold text-foreground-950 mb-4">
                  某内容平台创作者分成规则调整
                </div>
                <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
                  <div>
                    <div className="font-heading text-xl font-bold text-primary-600">21 天</div>
                    <div className="text-xs text-foreground-500">完整周期</div>
                  </div>
                  <div>
                    <div className="font-heading text-xl font-bold text-accent-600">6 个</div>
                    <div className="text-xs text-foreground-500">关键节点</div>
                  </div>
                  <div>
                    <div className="font-heading text-xl font-bold text-secondary-600">已复盘</div>
                    <div className="text-xs text-foreground-500">当前状态</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ol className="relative border-l border-background-300 pl-7">
              {trackingSteps.map((step) => (
                <li key={step.time} className="relative pb-8 last:pb-0 timeline-dot">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="text-xs font-medium text-primary-700 bg-primary-100 rounded-full px-2.5 py-1 whitespace-nowrap">
                      {step.time}
                    </span>
                    <span className="text-[11px] text-foreground-500 border border-background-300 rounded-full px-2.5 py-1 whitespace-nowrap">
                      {step.status}
                    </span>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}